












import { Component, Prop, Vue, Ref } from "vue-property-decorator";

@Component
export default class Settings extends Vue {
  apiKey: string = "";
  uid: string = "";
  isLoading = false

  save() {
    this.isLoading = true;
    localStorage.setItem("apiKey", this.apiKey);
    localStorage.setItem("uid", this.uid);
    if (window.webView) {
      window.webView.reload();
    } else {
      window.location.reload();
    }
    this.isLoading = false;
  }

  async mounted() {
    let key = localStorage.getItem("apiKey");
    if (key) {
      this.apiKey = key;
    }
    let uid = localStorage.getItem("uid");
    if (uid) {
      this.uid = uid;
    }
  }
}
